/**
 * Convert an Ajv-style `instancePath` (e.g. `/attributes/foo/bar`) into
 * the dot-separated form path (`foo.bar`) that the form's `nodeMap`
 * uses as keys.
 *
 * Strips known framework prefixes that appear in `instancePath` but
 * never in node ids:
 *  - `attributes.domainEntityAttributes.`
 *  - `domainEntityAttributes.`
 *  - `attributes.`
 *
 * The trailing `.` on each prefix is a boundary check — without it, a
 * property whose name happened to start with `attributes` would get
 * truncated. Pair this with `findClosestAncestorPath` to resolve the
 * resulting form path to a tree-node id.
 */
export const instancePathToFormPath = (instancePath: string): string => {
  const formatted = instancePath.replaceAll('/', '.').replace(/^\./, '');

  let normalized = formatted;
  [
    'attributes.domainEntityAttributes.',
    'domainEntityAttributes.',
    'attributes.',
  ].forEach((prefix) => {
    if (normalized.startsWith(prefix)) {
      normalized = normalized.slice(prefix.length);
    }
  });

  return normalized;
};
